<template>
  <p></p>
  <p><span lang="pl-PL">Jak chr&aacute;n&iacute;me va&scaron;e finančn&iacute; prostředky</span></p>
  <p>
    <span lang="pl-PL"
      >Je pro n&aacute;s nesm&iacute;rně důležit&eacute;, abyste si pečlivě přečetli n&iacute;že
      uveden&eacute; informace a plně porozuměli tomu, jak chr&aacute;n&iacute;me va&scaron;e
      finančn&iacute; prostředky uložen&eacute; u n&aacute;s!</span
    >
  </p>
  <p>
    <span lang="pl-PL"
      >Draph Solutions S.r.o. je společnost registrovan&aacute; v Česk&eacute; republice
      (&bdquo;CZ&ldquo;) pod identifikačn&iacute;m č&iacute;slem C 278807, se s&iacute;dlem Národní
      961/25, Staré Město, 110 00 Praha 1 (d&aacute;le jen &bdquo;Draph&ldquo;, &bdquo;my&ldquo;
      nebo &bdquo;n&aacute;s&ldquo;).</span
    >
  </p>
  <p>
    <span lang="pl-PL"
      >Na&scaron;e služby poskytujeme pod obchodn&iacute;m n&aacute;zvem Swipez.</span
    >
  </p>
  <p>
    <span lang="pl-PL"
      >Jsme poskytovatelem platebn&iacute;ch služeb v mal&eacute;m rozsahu (SSP). Jsme
      opr&aacute;vněni a regulov&aacute;ni Českou n&aacute;rodn&iacute; bankou (ČNB).</span
    >
  </p>
  <p>
    <span lang="pl-PL"
      >Na na&scaron;i obchodn&iacute; činnost, poskytov&aacute;n&iacute; na&scaron;ich služeb a
      vztahy s klienty a ČNB se vztahuj&iacute; z&aacute;kony Česk&eacute; republiky.</span
    >
  </p>
  <p>
    <span lang="pl-PL">Nejsme banka, ale chr&aacute;n&iacute;me va&scaron;e pen&iacute;ze</span>
  </p>
  <p>
    <span lang="pl-PL"
      >Je důležit&eacute; pochopit, že Draph nen&iacute; bankou a nenab&iacute;z&iacute;me
      bankovn&iacute; služby. Proto va&scaron;e finančn&iacute; prostředky uložen&eacute; u
      n&aacute;s nejsou chr&aacute;něny Kompenzačn&iacute;mi sch&eacute;maty Česk&eacute;
      n&aacute;rodn&iacute; banky.</span
    >
  </p>
  <p>
    <span lang="pl-PL"
      >Nicm&eacute;ně ochrana va&scaron;ich finančn&iacute;ch prostředků je jedn&iacute;m z
      na&scaron;ich kl&iacute;čov&yacute;ch z&aacute;vazků. Ochranu finančn&iacute;ch prostředků
      klientů považujeme za prioritn&iacute; &uacute;kol.</span
    >
  </p>
  <p>
    <span lang="pl-PL"
      >Za t&iacute;mto &uacute;čelem Draph využ&iacute;v&aacute; oddělen&eacute; &uacute;schovy jako
      hlavn&iacute; metodu ochrany finančn&iacute;ch prostředků klientů. Přij&iacute;m&aacute;me
      odpov&iacute;daj&iacute;c&iacute; opatřen&iacute; k zaji&scaron;těn&iacute; toho, že v
      př&iacute;padě insolvence společnosti Draph budou finančn&iacute; prostředky klientů
      vr&aacute;ceny v pln&eacute; v&yacute;&scaron;i a včas.</span
    >
  </p>
  <p>
    <span lang="pl-PL"
      >Metoda oddělen&eacute; &uacute;schovy zaji&scaron;ťuje, že v př&iacute;padě insolvence budou
      n&aacute;roky na&scaron;ich klientů vyplaceny z fondu vytvořen&eacute;ho z prostředků
      oddělen&yacute;ch od provozn&iacute;ho kapit&aacute;lu Draph a dal&scaron;&iacute;ch
      finančn&iacute;ch zdrojů.</span
    >
  </p>
  <p>
    <span lang="pl-PL"
      >Abychom efektivně ř&iacute;dili opatřen&iacute; k ochraně finančn&iacute;ch prostředků
      klientů, zm&iacute;rňovali souvisej&iacute;c&iacute; rizika a minimalizovali možn&eacute;
      negativn&iacute; důsledky, zavedli jsme př&iacute;sn&eacute; intern&iacute; politiky a postupy
      v souladu s platn&yacute;mi pr&aacute;vn&iacute;mi předpisy a obecně uzn&aacute;van&yacute;mi
      standardy.</span
    >
  </p>
  <p><span lang="pl-PL">Jak přesně chr&aacute;n&iacute;me va&scaron;e prostředky</span></p>
  <p><span lang="pl-PL">Oddělen&iacute; klientsk&yacute;ch prostředků</span></p>
  <p>
    <span lang="pl-PL"
      >V&scaron;echny finančn&iacute; prostředky klientů bez ohledu na jejich v&yacute;&scaron;i,
      zemi původu či c&iacute;lovou destinaci jsou uchov&aacute;v&aacute;ny odděleně od
      ostatn&iacute;ch finančn&iacute;ch prostředků společnosti Draph.</span
    >
  </p>
  <p><span lang="pl-PL">Denn&iacute; spr&aacute;va finančn&iacute;ch prostředků</span></p>
  <p>
    <span lang="pl-PL"
      >Zaji&scaron;ťujeme, že v&scaron;echny finančn&iacute; prostředky klientů jsou spr&aacute;vně
      a odpov&iacute;daj&iacute;c&iacute;m způsobem spravov&aacute;ny na denn&iacute; b&aacute;zi.
      Jakmile jsou finančn&iacute; prostředky přijaty, okamžitě je alokujeme na &uacute;čet
      &uacute;schovy.</span
    >
  </p>
  <p><span lang="pl-PL">&Uacute;čet &uacute;schovy v česk&eacute; bance</span></p>
  <p>
    <span lang="pl-PL"
      >Jakmile jsou přijaty klientsk&eacute; prostředky, automaticky je přesouv&aacute;me na
      speci&aacute;ln&iacute; &uacute;čet &uacute;schovy veden&yacute; u autorizovan&eacute;
      česk&eacute; banky &ndash; aktu&aacute;lně Fio Banka a.s. (Česk&aacute; republika,
      Evropsk&aacute; unie) &ndash; www.fio.cz.</span
    >
  </p>
  <p><span lang="pl-PL">Z&aacute;znamy o finančn&iacute;ch prostředc&iacute;ch</span></p>
  <p>
    <span lang="pl-PL"
      >Evidujeme ve&scaron;ker&eacute; zůstatky klientsk&yacute;ch &uacute;čtů v
      re&aacute;ln&eacute;m čase. Stejně tak n&aacute;&scaron; poskytovatel &uacute;čtu
      &uacute;schovy uchov&aacute;v&aacute; přesn&eacute; z&aacute;znamy o finančn&iacute;ch
      prostředc&iacute;ch klientů uložen&yacute;ch u n&aacute;s.</span
    >
  </p>
  <p>
    <span lang="pl-PL"
      >Nepř&iacute;stupnost klientsk&yacute;ch prostředků třet&iacute;m stran&aacute;m</span
    >
  </p>
  <p>
    <span lang="pl-PL"
      >Finančn&iacute; prostředky klientů nejsou př&iacute;stupn&eacute; na&scaron;im věřitelům,
      finančn&iacute;m instituc&iacute;m ani ž&aacute;dn&yacute;m jin&yacute;m třet&iacute;m
      stran&aacute;m.</span
    >
  </p>
  <p><span lang="pl-PL">Ochrana v př&iacute;padě insolvence</span></p>
  <p>
    <span lang="pl-PL"
      >V př&iacute;padě insolvence budou finančn&iacute; prostředky klientů vždy dostupn&eacute;
      klientům a budou vyplaceny přednostně z &uacute;čtu &uacute;schovy insolvenčn&iacute;m
      spr&aacute;vcem.</span
    >
  </p>
  <p><span lang="pl-PL">Pravideln&eacute; kontroly a monitorov&aacute;n&iacute;</span></p>
  <p>
    <span lang="pl-PL"
      >Nepřetržitě prov&aacute;d&iacute;me monitorov&aacute;n&iacute; rizik spojen&yacute;ch s
      ochranou finančn&iacute;ch prostředků a pravidelně revidujeme na&scaron;e postupy. M&aacute;me
      zaveden&eacute; kontroln&iacute; mechanismy, kter&eacute; pom&aacute;haj&iacute;
      předch&aacute;zet nedbalosti, &scaron;patn&eacute; spr&aacute;vě, podvodům a
      zneužit&iacute;.</span
    >
  </p>
  <p><span lang="pl-PL">M&aacute;te dotazy? Kontaktujte n&aacute;s!</span></p>
  <p>
    <span lang="pl-PL"
      >Pokud m&aacute;te jak&eacute;koliv dotazy nebo potřebujete dal&scaron;&iacute; informace o
      ochraně va&scaron;ich finančn&iacute;ch prostředků, nev&aacute;hejte n&aacute;s
      kontaktovat:</span
    >
  </p>
  <p><span lang="pl-PL">E-mail z&aacute;kaznick&eacute; podpory: support@swipez.eu</span></p>
  <p>
    <span lang="pl-PL"
      >N&aacute;&scaron; t&yacute;m odborn&iacute;ků v&aacute;m poskytne podrobn&eacute; a
      srozumiteln&eacute; vysvětlen&iacute; t&yacute;kaj&iacute;c&iacute; se ochrany
      klientsk&yacute;ch finančn&iacute;ch prostředků.</span
    >
  </p>
  <p>
    <span lang="pl-PL"
      >V&iacute;ce informac&iacute; o Kompenzačn&iacute;ch sch&eacute;matech Česk&eacute;
      n&aacute;rodn&iacute; banky naleznete na webov&yacute;ch str&aacute;nk&aacute;ch ČNB:
      www.cnb.cz</span
    >
  </p>
  <p><span lang="pl-PL">Kontakt na ČNB:</span></p>
  <p><span lang="pl-PL">E-mail: podatelna@cnb.cz</span></p>
  <p><span lang="pl-PL">Adresa: Senov&aacute;žn&aacute; 3, 115 03, Praha 1.</span></p>
  <p>Posledn&iacute; aktualizace: 01.10.2024</p>
</template>
